import request from '@/utils/request'

let Risk_controlApi = {

  /*风险管控列表*/
  list(data) {
    return request._post('/shop/plus.risk_control.Index/index', data);
},
/*添加风险管控*/
add(data) {
    return request._post('/shop/plus.risk_control.Index/add', data);
},
/*修改子风险管控*/
saveDetails(data) {
    return request._post('/shop/plus.risk_control.Index/saveDetails', data);
},
/*修改状态*/
updateStatus(data) {
    return request._post('/shop/plus.risk_control.Index/updateStatus', data);
},
/*修改风险管控*/
edit(data) {
    return request._post('/shop/plus.risk_control.Index/edit', data);
},
/*删除风险管控*/
del(data) {
    return request._post('/shop/plus.risk_control.Index/del', data);
},
/*风险管控详情*/
detail(data) {
  return request._post('/shop/plus.risk_control.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.risk_control.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.risk_control.Setting/getSetting', data, errorback);
    },
}
export default Risk_controlApi;



// WEBPACK FOOTER //
// ./src/api/risk_control.js